import { NgModule } from '@angular/core';;
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EsignatureListComponent } from './esignature-list/esignature-list.component';
import { RouterModule } from '@angular/router';
import { CustomPipesModule } from '../../shared/custom-pipes/custom-pipes.module';
import { ResizableModule } from 'app/setting/custom-form/resize/resizable.module';
import { ShowAssigneeModule } from 'app/shared/show-assignee/show-assignee.module';



@NgModule({
  declarations: [
    EsignatureListComponent
  ],
  exports: [
    EsignatureListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    RouterModule,
    ShowAssigneeModule,
    CustomPipesModule,
    ResizableModule,
  ]
})
export class EsignatureListModuleModule { }
